import React from 'react';
import styled from 'styled-components';
import { variables } from 'styleUtils';

import {
	defaultInputStyles,
	FormGroup,
	inputTransition,
	Label
} from './styles';

const StyledTextArea = styled.textarea`
  ${(props) => defaultInputStyles(props)}
  ${() => inputTransition()}
  border: solid 1px ${props => props.light ? variables.lineColor : variables.darkGrey};
  cols: ${props => props.cols ? props.cols : undefined};
  rows: ${props => props.rows ? props.rows : undefined};
  padding: 14px;
  &:hover {
    cursor: text;
  }
`;

const TextArea = ({
	name, value, label, onChange, className, disabled, formGroupClass,...rest
}) => (
	<FormGroup className={formGroupClass}>
		<StyledTextArea
			name={name}
			onChange={onChange}
			value={value}
			disabled={disabled}
			className={`${className} ${value && 'filled'}`}
			{...rest}
		/>
		<Label htmlFor={name}>{label}</Label>
	</FormGroup>
);

export default TextArea;
